export default {
  name: 'ToggleBox',

  props: {
    active: {
      type: Boolean,
      default: (() => false)
    },
    service: {
      type: Object,
      default: (() => { })
    },
  },

  data() {
    return {

    };
  },

  computed: {},

  methods: {
    handleClick() {
      this.$EventBus.$emit('Service/TOGGLE_MODAL_WITH_STATUS_CHANGE', this.service);
    },
  },
}


// WEBPACK FOOTER //
// ./src/components/Common/ToggleBox/component.js